import Api from '@/data/Api.ts';

const API_URL_SIGN_IN = '/sign-in';

export default class AuthenticationApi extends Api {
  /**
   * Sign in using the provided parameters (email, password).
   *
   * @param payload The payload to send with the request.
   * @returns {Promise} A promise containing an object of
   * {User} if successful, otherwise an emitted error.
   */
  signIn(payload: { email: string; password: string }): Promise<any> {
    return this.client.post(API_URL_SIGN_IN, payload, {
      headers: this._standardHeaderNoAuth(),
    });
  }
}
